import { FC } from 'react';
import { logEventAsArray } from '@/analytics';
import { Card } from '@mofid-securities/uikit';
import clsx from 'clsx';
import useRightSidebarItems, {
  IRightSidebarItem,
} from '@/layouts/Base/hooks/RightSidebarItems';
import { Icon } from '@/components/atomic/Icon';
import { Divider } from '@/components/Divider';
import { UserStatusMaybeButtonOrLink } from '@/userStatus/components';
import CardHeader from '../CardHeader';
import UserDetail from '../UserDetails';

const RightSidebar: FC = () => {
  const items = useRightSidebarItems();

  return (
    <Card className="!pb-[26px] md:!px-0 lg:!px-4" radius="2xl">
      <div className="px-5 py-4 md:mb-4 md:!px-2.5 md:!py-0 lg:!px-0">
        <UserDetail />
      </div>
      <Divider contrast="low" includedWidth={8} mb={16} />
      <CardHeader className="hidden lg:!block" title="منوی اصلی" />
      <nav className="md:!px-4 lg:!px-0">
        <ul className="flex flex-col">
          {items.map((item: IRightSidebarItem) => {
            const isActive: boolean = Boolean(item.checkActive(item));
            const currentIcon = isActive ? item.activeIcon : item.icon;
            return (
              !item?.isHidden && (
                <li
                  key={item.title}
                  className={clsx(
                    'relative flex-1',
                    item?.isDisabled &&
                      'cursor-default! pointer-events-none opacity-70'
                  )}
                >
                  <UserStatusMaybeButtonOrLink
                    forbiddenStatuses={item.forbiddenStatuses}
                    href={item?.href}
                    onClick={item?.onClick}
                  >
                    <div
                      className={`flex cursor-pointer flex-row items-center justify-center gap-x-2 rounded-lg px-4 py-2.5 transition-all duration-300 ${
                        isActive
                          ? 'mb-1.5 bg-neutral-filled-tertiary-enabled font-demibold text-gray-130'
                          : 'font-medium text-gray-filled-tertiary-enabled'
                      }`}
                      id={item.id}
                      title={item.title}
                      onClick={() => logEventAsArray(item?.analytics)}
                    >
                      <span
                        className={`absolute right-[-16px] h-[22px] rounded-l-[5px] bg-[#1ABEFF] transition-all duration-300 
                        ${isActive ? '!w-[4px]' : '!w-[0px]'}`}
                      />
                      {typeof currentIcon === 'string' ? (
                        <Icon icon={currentIcon as any} size={20} />
                      ) : (
                        currentIcon
                      )}
                      <span className="relative ml-auto hidden text-xs lg:!block">
                        {item.title}
                      </span>
                      {item.badge || null}
                    </div>
                  </UserStatusMaybeButtonOrLink>
                </li>
              )
            );
          })}
        </ul>
      </nav>
    </Card>
  );
};

export default RightSidebar;
